import ActionType from 'actions/ActionType'

export default (state = '', action) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'inbox') {
        return action?.payload?.[0]?.contact_id || ''
      }
      return state
    default:
      return state
  }
}
